<template>
<div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="d-flex " v-if="!flDetails">
        <div class="col-md-3">
            <FoldersCard v-on:GetFilter="GetFilter"></FoldersCard>
        </div>
    <div class="col-md-9">
        <TableCommissions  ref="tableCommission" :key="tablereload" v-on:edit="edit" v-on:deleteCommission="deleteCommission"></TableCommissions>
    </div>
    </div>
        <CommissionDetailsAdm :dataDetails="selectedComissao" v-if="flDetails" ></CommissionDetailsAdm>
</div>
</template>

<script>
import Commissions from '@/views/private/realestate/commissions/commissions.js'
export default Commissions
</script>

<style scoped>
.realtor-name{
    text-transform: capitalize;
    font-size: 18px;
    cursor: pointer;
    border-radius: 6px;
    padding: 6px;
    transition: .5s;
}

.realtor-name:hover{
    background-color: #e7e5e5;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissions/commissions.vue